<script lang="ts">
  import Card from '../lib/ui/Card.svelte';
  import { ReportDefinitionChangeLabel } from '../lib/report-definition-change-label';
  import { formatDateTime } from '../lib/time';
  import type { ReportDefinitionChange } from '../lib/api';

  interface Props {
    changes: ReportDefinitionChange[];
  }

  let { changes }: Props = $props();
</script>

<Card title="Histórico" count={changes.length}>
  <div class="rows">
    {#each changes as change (change.id)}
      {@const before = ReportDefinitionChangeLabel.value(change, change.before)}
      {@const after = ReportDefinitionChangeLabel.value(change, change.after)}
      <div class="row">
        <span class="sub mono">{formatDateTime(change.createdAt)}</span>
        <span class="who">
          <span class="name">{ReportDefinitionChangeLabel.action(change)} {ReportDefinitionChangeLabel.field(change).toLowerCase()}</span>
          <span class="sub">{change.changedBy ?? 'Sem autor'} · {change.source}</span>
        </span>
        <span class="who values">
          {#if before !== null}<span class="sub">De {before}</span>{/if}
          {#if after !== null}<span class="sub">Para {after}</span>{/if}
        </span>
      </div>
    {:else}
      <p class="empty">Nenhuma mudança registrada.</p>
    {/each}
  </div>
</Card>

<style>
  .rows {
    display: flex;
    flex-direction: column;
  }
  .row {
    display: grid;
    grid-template-columns: 90px minmax(0, 1fr) minmax(0, 2fr);
    align-items: start;
    gap: var(--space-4);
    padding: var(--space-3) 0;
    border-top: 1px solid var(--border-subtle);
  }
  .row:first-child {
    border-top: none;
  }
  .who {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .values .sub {
    overflow-wrap: anywhere;
  }
  .name {
    color: var(--text-primary);
    font-weight: 500;
  }
  .sub {
    color: var(--text-tertiary);
    font-size: 12px;
  }
  .empty {
    margin: 0;
    padding: var(--space-4) 0;
    text-align: center;
    color: var(--text-tertiary);
    font-size: 12px;
  }
</style>
